<div class="rowTitle">
  <div class="title">Welcome to cloudigo Traveller, {{meta.displayName() || '😀'}}!</div> 
    <div class="subtitle">{{subtitle}}</div>
</div>
<div id="banner">
  <img class="banner-image" [src]="bannerImg" alt="Scenic Banner"/>
  <img class="banner-image_sm" [src]="smBannerImg" alt="Scenic Banner"/>
  <div id="bannerText">
    <h1 id="bannerTitle">{{bannerTitle}}</h1>
  </div>
</div>
@if(offers.activities.length){
  <div class="banner-tip">
      <div class="tipText">
          <span class="font-bold">Tip -</span> You can book your excursions at a discount on the cloudigo app ahead of time!
    </div>
  </div>
}
<!-- What to do when you arrive in Malta? -->
<div class="f-main-center" style="background-color: #ebf3ff;">
  <div id="midSection" class="section">
    <div class="row section-title">What to do when you arrive in Malta?</div>
    <div class="row">
      <div class="subText">
        When you arrive in Malta, you will be able to
        <span class="font-bold">use</span> all the other offers in your Traveller plan
        including <span class="font-bold"> fashion brands</span> &amp;
        <span class="font-bold">more!</span>
      </div>
    </div>
    <div class="row mobileCol">
      <div class="subsection">
        <div class="row">
          <div class="number">1</div>
          <div class="listText"><span class="font-bold">Download</span> the app</div>
        </div>
        <div class="row store-ctas rowImg px-10">
          <a routerLink="/android" target="_blank">
            <img src="old/playstore-btn.png" alt="Get cloudigo on the playstore"/>
          </a>
          <a routerLink="/ios" target="_blank">
            <img src="old/appstore-btn.png" alt="Get cloudigo on the appstore"/>
          </a>
        </div>
        <div class="row">
          <div class="number">2</div>
          <div class="listText">
            <span class="font-bold">Login</span> with your account
          </div>
        </div>
        <div class="row rowImg">
          <img id="loginImg" src="old/tourist/btn_login.png" alt="Login"/>
        </div>
        <div class="row">
          <div class="number">3</div>
          <div class="listText">
            <span class="font-bold">Save</span> at restaurants, fashion stores &amp; more
            in Malta
          </div>
        </div>
      </div>
      <div class="subsection imageSection">
        <img id="signUpImg" src="old/tourist/signup.png" alt="Signup" />
      </div>
    </div>
  </div>
</div>

<!-- How to use cloudigo for food and fashion discounts whilst in Malta -->
<div class="col f-cross-center" style="background-color: #ffffff;">
  <div id="useCldg" class="section">
    <div class="listTitle black-font">
      How to use cloudigo for food and fashion discounts whilst in Malta
    </div>
    <div class="row mobileCol" style="align-items: flex-start; justify-content: space-around;">
      <div class="col-3">
        <div class="row">
          <img class="stepIcon" src="old/tourist/trolley.svg" alt="Cash Register"/>
          <div class="col stepCol">
            <div class="stepsTitle">1. Buy Traveller &amp; Install app</div>
            <div>
              <div class="stepsText">
                Purchase the cloudigo Traveller plan online, sign up and download the cloudigo app on your phone
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="row">
          <img class="stepIcon" src="old/tourist/store.svg" alt="QR Code"/>
          <div class="col stepCol">
            <div class="stepsTitle">2. Visit Store or Restaurant</div>
            <div>
              <div class="stepsText">
                When asking for the bill or while at the cashpoint, find the offer, click on <span class="font-bold">Get Code</span> and press on <span class="font-bold">Use Now</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="row">
          <img class="stepIcon" src="old/tourist/scan.svg" alt="Savings"/>
          <div class="col stepCol">
            <div>
              <div class="stepsTitle">3. Scan &amp; Save</div>
            </div>
            <div class="stepsText">
              Scan the <span class="font-bold">code</span> provided by the cashier to validate your discount &amp; enjoy
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Need any assistance? -->
<div id="astCol" class="col">
  <div class="section carousel-section">
    <div id="astRow" class="row align-center">
      <div id="astImg" class="subsection row">
        <img loading="lazy" class="side-img" src="old/tourist/assistance.webp" alt="Assistance Image"/>
      </div>
      <div class="subsection">
        <div id="astDiv" class="col">
          <h2 id="astTitle">Need any assistance?</h2>
          <p id="astText"> Let us help you manage your cloudigo Traveller plan. Simply send us a direct message on Facebook or Contact us directly.</p>
          <a id="astBtn" class="button" [routerLink]="['/traveller', 'contactus.html']" target="_blank" rel="help">CONTACT US</a>
        </div>
      </div>
    </div>
  </div>
</div>